/** Base pathname for recruitment vacancy APIs (use for MSW regex builders). */
export const VACANCY_BASE_PATH = '/rec/vacancy';

export const VACANCY_ENDPOINTS = {
  search: `${VACANCY_BASE_PATH}/search`,
  list: `${VACANCY_BASE_PATH}/list`,
  add: `${VACANCY_BASE_PATH}/add`,
  vacancyCodes: `${VACANCY_BASE_PATH}/vacancyCodes`,
  deleteQuestion: (questionId: number) =>
    `${VACANCY_BASE_PATH}/deleteQuestion?questionId=${questionId}`,
  /** Route params from `useParams` are strings; services may pass numbers. */
  byId: (id: string | number) => `${VACANCY_BASE_PATH}/${id}`,
  clone: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/clone`,
  publishJob: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/publishJob`,
  deleteJob: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/deleteJob`,
  withdraw: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/withdraw`,
  approve: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/approve`,
  questions: (id: string | number, questionLevel?: number) => {
    const path = `${VACANCY_BASE_PATH}/${id}/questions`;
    return questionLevel === undefined ? path : `${path}?questionLevel=${questionLevel}`;
  },
  updateQuestions: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/updateQuestions`,
  updateDetails: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/updateDetails`,
  updateJD: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/updateJD`,
  updateMedia: (id: string | number) => `${VACANCY_BASE_PATH}/${id}/updateMedia`,
} as const;
